import React from 'react';

const Intro = () => (
  <section id="intro" className="page-accent">
    <div id="intro-text">
      <div id="intro-header" className="header-invert">
        Hello World! I&apos;m James.
      </div>
      <p id="intro-paragraph" className="paragraph-invert">
        I am currently a Computer Science & Mechatronics Engineering UNSW
        graduate and Frontend Engineer at Canva with a passion for App
        Development, Data Science and Robotics. I also enjoy designing good
        UI/UX and teaching others. On the side, I enjoy playing sports casually
        such as swimming, volleyball, billiards and chess. Nice to meet you!
        &nbsp;
        <span aria-label="smile" role="img">
          &#128522;
        </span>
      </p>
    </div>
  </section>
);

export default Intro;
